import { useFormik, useFormikContext } from 'formik';
import { useEffect, useMemo, useState } from 'react';
import { Col, Nav, Row, Tab } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams, Outlet } from 'react-router-dom';
import Select, { StylesConfig } from "react-select";
import { toast } from 'react-toastify';
import * as Yup from "yup";
import Ribbon from '../../../core/common/ribbon/ribbon';
import { setApiData } from '../../../Features/authslice';
import { useCreateLeadMutation, useGetActiveContactLookupQuery, useGetAllActiveUsersQuery, useGetDefaultlookupsQuery, useGetExistingLeadProspectsLookupQuery, useLazyGetLeadProspectByIdQuery, useLazyGetLeadProspectInfobyIdQuery, useUpdateLeadProspectMutation } from '../../../services/EndPointsApis';
import { svgIcons } from '../../../style/fonts/SvgIcons';
import GeneralTab from './LeadProspectTabs/GeneralTab';
import IntegrationTab from './LeadProspectTabs/IntegrationTab';
import ProgressStepperLead from './ProgressStepperLeadProspect/ProgressBarLead';
import ModalComponent from '../../../core/common/modal/ModalComponent';
import useNavigationConfirmation from '../../../core/common/ConfirmationModaltsx/ConfirmModal';
import { useDirtyState } from '../../../core/common/ConfirmationModaltsx/DirtyStateContext';
import React from 'react';

const AddLead = () => {
    const location = useLocation();
    const isReadOnly = location.pathname.includes('viewLead');
    const isEditing = location.pathname.includes('editLead');
    // const [currentStep, setCurrentStep] = useState<number>(1);
    // const [completedStep, setCompletedStep] = useState<number>(0);
    const [disabledata, setDisabledata] = useState(false)
    const params = useParams()
    const prospectId = params?.id
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const handleBack = () => {
        navigate('/leadsProspect')
    }

    const handleEdit = () => {
        navigate('/editLead/:id')
    }

    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };


    const items = [
        {
            label: 'Back', tooltipLabel: "Back", icon: svgIcons.BackIcon, onClick: handleBack,
        },
        // {
        //     label: 'Edit', tooltipLabel: "Edit", icon: svgIcons.SaveIcon, onClick: handleEdit, hidden: !isReadOnly ? true : false,
        // },
    ]

    //create Lead Api
    const [createLead, { data, isError, error, isSuccess, isLoading }] = useCreateLeadMutation();
    const [UpdateLead, { data: UpdateLeadData, isError: updateLeadIsError, error: updateLeadError, isSuccess: updateLeadIsSuccess, isLoading: updateIsLoading }] = useUpdateLeadProspectMutation();

    //get all default lookups
    const { data: getdefaultLookups, refetch: defualtRefetch } = useGetDefaultlookupsQuery('');

    // getLeadsById
    // const [trigger, { data: getLeadsByID }] = useGetLeadProspectByIdQuery({ prospectId: prospectId });
    const [triggerExistingLeadData, { data: getExistingLeadsByID }] = useLazyGetLeadProspectInfobyIdQuery();

    // get all Leads data
    const [trigger, { data: getAllLeadsById }] = useLazyGetLeadProspectByIdQuery();

    //All Leads Prospect
    // const [allLeadsTrigger,{ data:allLeadsData}] =useLazyGetLeadsProspectsQuery()

    //All contacts API
    const { data: getContactsLookup, refetch: refetchContactsLookup } = useGetActiveContactLookupQuery('')
    //Existing Leads Lookup

    const { data: getExistingLeadsLookups, refetch: existingLeadsRefetch } = useGetExistingLeadProspectsLookupQuery('');
    //Get All Active Users
    const { data: getallActiveUsers, refetch: activeUsersRefetch } = useGetAllActiveUsersQuery('');
  
    //formik
    const LeadsSchema = Yup.object().shape({
        name: Yup.string()
            .required("Name is required"),
        prospectDate: Yup.string()
            .required("Prospect Date is required"),
        lst_LeadQualityCode: Yup.object().shape({
            id: Yup.number().required('Lead Quality Code  is required'),
            value: Yup.string().required('Lead Quality Code  is required'),
        }),
        lst_MethodOfInquiry: Yup.object().shape({
            id: Yup.number().required('Method of Inquiry is required'),
            value: Yup.string().required('Method of Inquiry  is required'),
        }),
        lst_Subject: Yup.object().shape({
            id: Yup.number().required('Subject is required'),
            value: Yup.string().required('Subject is required'),
        }),
        lst_Leads: Yup.object().shape({
            id: Yup.string().required('Lead Prospect is required'),
            value: Yup.string().required('Lead Prospect is required'),
        }).when('lst_ExistingLead.id', ([id], schema) => {
            return parseInt(id) === 1
                ? schema.shape({
                    id: Yup.string().required('Lead Prospect is required'),
                    value: Yup.string().required('Lead Prospect is required'),
                })
                : schema.shape({
                    id: Yup.string(),
                    value: Yup.string(),
                });
        }),
        lst_ProjectType: Yup.object().shape({
            id: Yup.number().required('Project Type is required'),
            value: Yup.string().required('Project Type is required'),
        }),

    })
    const initialValues = {
        currentStep: 0,
        name: '',
        recordNumber: "",
        firstName: "",
        lastName: "",
        lst_Prefix: {
            id: 0,
            value: ""
        },
        title: "",
        emailAddress: "",
        mainPhone: "",
        mobilePhone: "",
        lst_MainPhoneType: {
            id: 0,
            value: ""
        },
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressCity: "",
        freshAptTime: "",
        addressStateOrProvince: "",
        addressPostalCode: "",
        addressComposite: "",
        lst_MethodOfInquiry: {
            id: 0,
            value: ""
        },
        prospectDate: "",
        consultationDate: "2024-09-04T10:28:04.109Z",
        projectDetails: "",
        leadIntakeNotes: "",
        leadQualificationNotes: "",
        lst_ProjectType: {
            id: 0,
            value: ""
        },
        projectBudget: 0,
        projectBudgetNotes: "",
        lst_VerifiedProspect: {
            id: 0,
            value: ""
        },
        lst_VerifiedContact: {
            id: 0,
            value: ""
        },
        lst_ExistingLead: {
            id: 2,
            value: "NO"
        },
        lst_LeadQualityCode: {
            id: 0,
            value: ""
        },
        lst_LeadProspectStatusCode: {
            id: 0,
            value: ""
        },
        createdOn: "2024-09-04T10:28:04.109Z",
        modifiedOn: "2024-09-04T10:28:04.109Z",
        overriddenCreatedOn: "2024-09-04T10:28:04.109Z",
        createdBy: 0,
        modifiedBy: 0,
        createdOnBehalfBy: 0,
        modifiedOnBehalfBy: 0,
        enteredBy: 0,
        leadSource: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        lst_LeadSourceCode: {
            id: 0,
            value: ""
        },
        lst_Leads: {
            id: "00000000-0000-0000-0000-000000000000",
            value: ''
        },
        leadSourceNotes: "",
        leadTaker: 0,
        leadInquiry: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        webFormEntry: 0,
        existingLead: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        description: "",
        lst_FeedStreamType: {
            id: 0,
            value: ""
        },
        lst_FeedStreamObjectType: {
            id: 0,
            value: ""
        },
        feedStreamObjectName: "",
        feedStreamObjectId: "",
        feedStreamReferrer: "",
        feedStreamSearchPhrase: "",
        feedStreamContextId: "",
        feedStreamContext: "",
        lst_FeedStreamInputDeviceType: {
            id: 0,
            value: ""
        },
        feedStreamData: "",
        feedStreamSource: "",
        utmSource: "",
        lst_PrintedCirculation: {
            id: 0,
            value: ""
        },
        trafficSource: "",
        lst_DigitalBlast: {
            id: 0,
            value: ""
        },
        contactPreferences: "",
        lst_FeedStreamOperatingSys: {
            id: 0,
            value: ""
        },
        roofing: "",
        siding: "",
        stuccoOrEIFS: "",
        lst_AIroomProductAndServices: {
            id: 0,
            value: ""
        },
        michaelBennetHomes: "",
        lambFinancial: "",
        exteriormakover: "",
        elevations: "",
        addition: "",
        remodel: "",
        revive: "",
        appliances: "",
        lst_Radio: {
            id: 0,
            value: ""
        },
        lst_TV: {
            id: 0,
            value: ""
        },
        lst_Signage: {
            id: 0,
            value: ""
        },
        lst_Broadcast: {
            id: 0,
            value: ""
        },
        lst_Influencer: [{
            id: 0,
            value: ''
        }],
        lst_EventsExhibits: {
            id: 0,
            value: ""
        },
        lst_EnteredBy: {
            id: 0,
            value: ""
        },
        lst_LeadTaker: {
            id: 0,
            value: ""
        },
        lst_Owner: {
            id: 0,
            value: ""
        },
        targetPopulation: "",
        hhIncome250K: true,
        hhValue400K: true,
        ageGroup3474: "",
        zillowEstimate: "",
        lst_WebSearchEngine: {
            id: 0,
            value: ""
        },
        lst_SearchEnginePaid: {
            id: 0,
            value: ""
        },
        lst_WebSearchEngineOrganic: {
            id: 0,
            value: ""
        },
        lst_WebSocialMediaRoot: {
            id: 0,
            value: ""
        },
        lst_WebSocialMediaNetwork: {
            id: 0,
            value: ""
        },
        lst_ReferralProgram: {
            id: 0,
            value: ""
        },
        lst_WebsiteDirect: {
            id: 0,
            value: ""
        },
        lst_WebsiteThirdParty: {
            id: 0,
            value: ""
        },
        lst_Subject: {
            id: 0,
            value: ""
        },
        airoom: 0,
        masonry: "",
        bathroomRemodel: 0,
        feedStreamRecordIdentifier: "",
        feedStreamPostId: "",
        feedRawReferrer: "",
        freshAptDate: '',
        lst_Account: {
            id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            value: ""
        },
        lst_Contact: {
            id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            value: ""
        },
        ctmCallerID: "",
        lst_ProjectStatus: {
            id: 0,
            value: ""
        },
        lst_SubStatus: {
            id: 0,
            value: ""
        },
        lst_EvaluateFit: {
            id: 0,
            value: ""
        },
        lst_ConfirmInterest: {
            id: 0,
            value: ""
        },
        lst_Rating: {
            id: 0,
            value: ""
        },
        lst_CanPromote: {
            id: 0,
            value: ""
        },
        lst_StatusReason: {
            id: 0,
            value: ""
        },
        lst_Status: {
            id: 1,
            value: "Active"
        },
        lst_QualificationReasonCode: {
            id: 0,
            value: ""
        },
        lst_LeadSourceType: {
            id: 0,
            value: ""
        },
        lst_Need: {
            id: 0,
            value: ""
        },

    }

    const formik = useFormik({
        validationSchema: LeadsSchema,
        initialValues,

        onSubmit: (values) => {

            if (isEditing) {
                UpdateLead({ ...values })
            }
            else {
                createLead({ ...values });
            }
        },

    });
    // useEffect(() => {
    //     LeadsSchema.validate(initialValues)
    //         .then(valid => console.log('Validation successful:', valid))
    //         .catch(err => console.error('Validation failed:', err.errors));
    // }, []);

    const { resetForm } = formik;

    const [activeState, SetActiveState] = useState(false)
    const apiResponseCurrentStep = getAllLeadsById?.result?.currentStep + 1;
    const [currentStep, setCurrentStep] = useState<number>(
        isEditing || isReadOnly ? apiResponseCurrentStep || 1 : 1
    );
    useEffect(() => {

        if (isSuccess && activeState === false) {
            toast.success(data?.message);
            resetForm()
            // allLeadsTrigger('')
            navigate('/leadsProspect')
            // navigate(route.manageusers);
        }
        if (updateLeadIsSuccess && activeState === false) {
            toast.success(UpdateLeadData?.message);
            trigger({ prospectId: prospectId })
            // allLeadsTrigger('')
            // navigate('/leadsProspect')
        }
        if (formik.values.currentStep === 3 && formik.values.lst_QualificationReasonCode?.id === 1 && formik.values.lst_Status?.id === 1) {
            setTimeout(() => {
                trigger({ prospectId: prospectId });
            }, 1000);
        }
        if (formik.values.currentStep === 5) {
            trigger({ prospectId: prospectId });
        }
        // if (isEdit && isSuccess) {
        //   toast.success(data?.message);
        //   refetch()
        // }
    }, [isSuccess, data, updateLeadIsSuccess, UpdateLeadData, formik.values.currentStep]);

    const handleSubmit = () => {
        formik.handleSubmit()
        SetActiveState(false)
    }
    const handleSaveClose = () => {
        formik.handleSubmit()
        setTimeout(() => {
            navigate('/leadsProspect')
        }, 1000);
    }    
    
    useEffect(() => {
        if (isError && error) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
                errorMessage = (error.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
        if (updateLeadIsError && updateLeadError) {
            let errorMessage: string = 'Something went wrong';

            if ('data' in updateLeadError && updateLeadError.data && typeof updateLeadError.data === 'object' && 'message' in updateLeadError.data) {
                errorMessage = (updateLeadError.data as { message: string }).message;
            }
            toast.error(errorMessage);
        }
    },
        [isError, error, updateLeadIsError, updateLeadError]);

    useEffect(() => {
        if (isEditing && getExistingLeadsByID?.result && Object.keys(getExistingLeadsByID?.result).length > 0) {

            setDisabledata(true)
        }
    }, [getExistingLeadsByID]);
    useEffect(() => {
        if (getdefaultLookups) {
            dispatch(setApiData(getdefaultLookups));
        }
    }, [])

  // Extract dirty state from formik
  const isDirty = formik.dirty;

  const { setIsDirty } = useDirtyState();

  useEffect(() => {
    setIsDirty(isDirty); 
  }, [isDirty, setIsDirty]);

    return (
        <>  
            <div className="page-wrapper">
                <div className="content">
                    <div className='row'>
                        <div className='col-md-12'>
                            <Ribbon
                                items={items}
                                // ribbonHeading={isReadOnly ? 'Read Lead Prospect' : isEdit ? 'Edit Lead Prospect' : 'Add Lead Prospect'}
                                buttonText={isEditing
                                    ? (updateIsLoading ? 'Please wait...' : 'Update')
                                    : (isReadOnly
                                        ? ''
                                        : (isLoading
                                            ? 'Please wait...'
                                            : 'Save'
                                        )
                                    )}
                                buttonText2={isEditing ? 'Update & Close' : ''}
                                buttonClass='btn ribbon-btn'
                                onClickbtn={handleSubmit}
                                onClickbtn2={handleSaveClose}
                                disabled={isLoading || updateIsLoading}
                            />
                        </div>
                    </div>
                    <div className='mt-2'>
                        <Tab.Container id="left-tabs-example" defaultActiveKey="general">
                            <Row>
                                <Col sm={12}>
                                    <div className='card'>
                                        <div className='card-body p-3'>
                                            <div className='d-flex justify-content-between mb-3'>
                                                <div className=''>
                                                    {isEditing || isReadOnly ?
                                                        <h4 className='color-red'>{getAllLeadsById?.result?.recordNumber}<span className='fs-12 text-muted'> - Saved</span></h4> :
                                                        <></>
                                                    }
                                                    <p>{isEditing ? 'Edit Lead Prospect' : isReadOnly ? 'View Lead Prospect' : 'New Lead Prospect'}</p>
                                                </div>
                                                <div className='d-flex gap-2'>
                                                    <div>
                                                        <p className='mb-0 fs-13 fw-600'>
                                                            {formik.values.lst_LeadTaker?.value || '....'}
                                                        </p>
                                                        <p className='fs-11'>
                                                            Lead Taker
                                                        </p>
                                                    </div>
                                                    <div style={{ borderRight: '1px solid gray' }}></div>
                                                    <div>
                                                        <p className='mb-0 fs-13 fw-600'>
                                                            {formik.values.lst_Owner?.value || '....'}
                                                        </p>
                                                        <p className='fs-11'>
                                                            Owner
                                                        </p>
                                                    </div>
                                                    <div style={{ borderRight: '1px solid gray' }}></div>
                                                    <div>
                                                        <p className='mb-0 fs-13 fw-600'>
                                                            {formik.values.lst_Status?.value || '....'}
                                                        </p>
                                                        <p className='fs-11'>
                                                            Status
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <div className="form-sorts dropdown">
                                                            <button
                                                                className="btn border-gray dropdown-toggle"
                                                                type="button"
                                                                // id={idValue}
                                                                data-bs-toggle="dropdown"
                                                                data-bs-auto-close='false'
                                                                aria-expanded="false"
                                                            >
                                                            </button>
                                                            <div className="filter-dropdown-menu dropdown-menu  dropdown-menu-md-end p-2">
                                                                <div className="filter-set-view">
                                                                    <div className="filter-set-head">
                                                                        <div className="w-100">
                                                                            <div className='d-flex justify-content-between align-items-center mt-2 w-100' >
                                                                                <label className='input-label w-25'>Lead Taker </label>
                                                                                <Select
                                                                                    styles={customStyles}
                                                                                    className="select w-75 "
                                                                                    options={getallActiveUsers?.result?.map((option: any) => ({
                                                                                        label: option?.userName,
                                                                                        value: option?.userId
                                                                                    }))}
                                                                                    value={
                                                                                        formik.values?.lst_LeadTaker
                                                                                            ? {
                                                                                                value: formik.values?.lst_LeadTaker?.id,
                                                                                                label: formik.values?.lst_LeadTaker?.value || '',
                                                                                            }
                                                                                            : null
                                                                                    }
                                                                                    isDisabled={isReadOnly}
                                                                                    onChange={(selectedOption: any) => {
                                                                                        formik.setFieldValue('lst_LeadTaker.id', selectedOption.value);
                                                                                        formik.setFieldValue('lst_LeadTaker.value', selectedOption.label);
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                            <div className='d-flex justify-content-between align-items-center mt-2 w-100' >
                                                                                <label className='input-label w-25'>Owner </label>
                                                                                <Select
                                                                                    styles={customStyles}
                                                                                    className="select w-75 "
                                                                                    options={getallActiveUsers?.result?.map((option: any) => ({
                                                                                        label: option?.userName,
                                                                                        value: option?.userId
                                                                                    }))}
                                                                                    value={
                                                                                        formik.values?.lst_Owner
                                                                                            ? {
                                                                                                value: formik.values?.lst_Owner?.id,
                                                                                                label: formik.values?.lst_Owner?.value || '',
                                                                                            }
                                                                                            : null
                                                                                    }
                                                                                    isDisabled={isReadOnly}
                                                                                    onChange={(selectedOption: any) => {
                                                                                        formik.setFieldValue('lst_Owner.id', selectedOption.value);
                                                                                        formik.setFieldValue('lst_Owner.value', selectedOption.label);
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <ProgressStepperLead
                                                // currentStep={currentStep}
                                                // setCurrentStep={setCurrentStep}
                                                // setCompletedStep={setCompletedStep}
                                                // completedStep={completedStep}
                                                SetActiveState={SetActiveState}
                                                formik={formik} getdefaultLookups={getdefaultLookups}
                                                isReadOnly={isReadOnly} getLeadsByID={getAllLeadsById} getContactsLookup={getContactsLookup} disabledata={disabledata}
                                                currentStep={currentStep}
                                                setCurrentStep={setCurrentStep} />

                                            <Nav>
                                                <Nav.Item>
                                                    <Nav.Link className='nav-tabs' eventKey="general">General</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link className='nav-tabs' eventKey="integration">Integration</Nav.Link>
                                                </Nav.Item>
                                                {/* <Nav.Item>
                                                    <Nav.Link className='nav-tabs' eventKey="notes">Notes</Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link className='nav-tabs' eventKey="tasks">Tasks</Nav.Link>
                                                </Nav.Item> */}
                                            </Nav>

                                        </div>
                                    </div>
                                </Col>
                                <Col sm={12}>
                                    <form onSubmit={formik.handleSubmit}>
                                        <Tab.Content>
                                            <Tab.Pane eventKey="general">
                                                <GeneralTab
                                                    formik={formik}
                                                    initialValues={initialValues}
                                                    getdefaultLookups={getdefaultLookups}
                                                    getLeadsByID={getAllLeadsById}
                                                    getContactsLookup={getContactsLookup}
                                                    getExistingLeadsLookups={getExistingLeadsLookups}
                                                    trigger={trigger}
                                                    triggerExistingLeadData={triggerExistingLeadData}
                                                    getExtLeadsById={getExistingLeadsByID}
                                                    refetchContactsLookup={refetchContactsLookup}
                                                    disabledata={disabledata}

                                                />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="integration">
                                                <IntegrationTab formik={formik} initialValues={initialValues} getdefaultLookups={getdefaultLookups} getallActiveUsers={getallActiveUsers} isReadOnly={isReadOnly} />
                                            </Tab.Pane>
                                            {/* <Tab.Pane eventKey="notes"><LeadNotes /></Tab.Pane>
                                            <Tab.Pane eventKey="tasks"><LeadUserTask /></Tab.Pane> */}

                                        </Tab.Content>
                                    </form>


                                </Col>
                            </Row>
                        </Tab.Container>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddLead

function setNextPath(arg0: string) {
    throw new Error('Function not implemented.');
}
